import React from 'react'
import { SprintPacketHydrated } from '@marketing-milk/interfaces'
import { SurfacePalette, type } from '../../tokens'
import { SectionCard } from './SectionCard'

interface Props {
  palette: SurfacePalette
  packet: SprintPacketHydrated
}

export const FinalApprovalSection = ({ palette, packet }: Props) => {
  const count = packet.approvals.length
  return (
    <SectionCard
      palette={palette}
      sectionKey="final-approval"
      title="Final Approval"
      commentAnchor={{
        type: 'section',
        id: `${packet.id}:final-approval`,
        label: 'Final Approval',
      }}
    >
      <p style={{ margin: 0, fontSize: type.size.body, color: palette.textMuted }}>
        Per-campaign approval rows land in v0.10. {count} approval{count === 1 ? '' : 's'} on this
        packet so far.
      </p>
    </SectionCard>
  )
}
